<div class="ub-topbar">
  <div class="ub-search-filter-container">
    <!-- filter component common start  -->
    <ubi-cell-top-bar-filter [mainScreen]="mainScreen" [subScreen]="subScreen"
      [workOrderCapabilityType]="workOrderCapabilityType"
    [hidden]="!_topBarConf?.currTopBarConfig?.value?.filter"></ubi-cell-top-bar-filter>
    <!-- filter component common end  -->

    <!--  subpanel dropdown start -->
    @if (displaySubpanel) {
      <ubi-cell-subpanel-dropdown [mainScreen]="mainScreen" [subScreen]="subScreen"
      ></ubi-cell-subpanel-dropdown>
    }
    <!--  subpanel dropdown end-->
  </div>

  <ng-container *ubiDisplayWhenMultiSubpanelSelected="false">
    <div (appClickOutside)="outsideClick($event)" [hidden]="!_topBarConf?.currTopBarConfig?.value?.tag || hideTagFilter" class="ub-tag-select">
      <!-- <button mat-icon-button (click)="onTagBlockExpand()" class="ubicon-tag-button" [disabled]="_topBarConf?.loadTagComponent"

      [matTooltipDisabled] = "!_topBarConf?.loadTagComponent"
      matTooltip="{{'nodes_loading_message'|translate}}"
      [ngClass]="{'disable-cursor': _topBarConf?.loadTagComponent }" >
      <span class="ubicon-tag icon-md"></span>
    </button> -->
    <!-- <button mat-button class="ub-button ub-button-radius" (click)="onTagBlockExpand()"
    [disabled]="_topBarConf?.loadTagComponent"
    [matTooltipDisabled]="!_topBarConf?.loadTagComponent"
    matTooltip="{{ (mainScreen == 'notifications' && productTypesList.length > 1) ? ('product_type_change_info_message' |translate) :( 'nodes_loading_message' |translate)}}"
    [ngClass]="{'disable-cursor': _topBarConf?.loadTagComponent }">
    <ubi-cell-icons name="tags-icon"></ubi-cell-icons>
  </button> -->
  <span
    matTooltipClass="ub-tooltip"
          [matTooltip]="
            (mainScreen === 'notifications' && selectedProductChip == 'all_products')
              ? ('product_type_change_info_message' | translate)
              : (_topBarConf?.loadTagComponent ? ('nodes_loading_message' | translate) : ('tags_lable' | translate))
          ">
    <button mat-button class="ub-button ub-button-radius" (click)="onTagBlockExpand()"
      [disabled]="_topBarConf?.loadTagComponent"
      [ngClass]="{'disable-cursor': _topBarConf?.loadTagComponent }">
      <ubi-cell-icons name="tags-icon"></ubi-cell-icons>
    </button>
  </span>

  @if (expandTagBlock) {
    <div>
      <ubi-cell-top-bar-tag [capabilityType]="mainScreen"
      [selectedAlertProductType]="selectedAlertProductType"></ubi-cell-top-bar-tag>
    </div>
  }
</div>
</ng-container>
<ng-container>
  @if (isPowerQualityScreen() && !isTagCreationScreen) {
    <div class="tx-topbar-wrapper" (appClickOutside) = "dropdownOutsideClick($event)">
      <div class="select-title" (click)="onDropdownExpand()" [ngClass]="expandDropdownBlock ? 'expand':''">
        <h3 class="font-size-24"> {{ currSelectedPowerQualityType?.value | translate }} | {{ nodeCount || 0 }} Tx</h3> <ubi-cell-icons name="arrow-down-icon"></ubi-cell-icons></div>
        @if (expandDropdownBlock) {
          <div class="ub-topbar-page-menu">
            <div class="ub-list">
              <div class="ub-list-items">
                <ul>
                  @for (powerQualityType of powerQualityTypes; track powerQualityType) {
                    <li (click)="powerQualityType.key != currSelectedPowerQualityType?.key && onSelectPowerQualityType(powerQualityType)">
                      <div class="ub-list-item">{{ powerQualityType?.value | translate }}</div>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </ng-container>

  @if (mainScreen == 'planning') {
    <div class="tx-topbar-wrapper" (appClickOutside)="dropdownOutsideClick()">
      <div class="select-title" (click)="onDropdownExpand()"
        [ngClass]="expandDropdownBlock ? 'expand':''">
        <h3 class="font-size-24"> {{ currSelectedPhase | translate }} | {{ nodeCount || 0 }}  {{ 'poles' | translate }}</h3> <ubi-cell-icons
      name="arrow-down-icon"></ubi-cell-icons>
    </div>
    @if (expandDropdownBlock) {
      <div class="ub-topbar-page-menu">
        <div class="ub-list">
          <div class="ub-list-items">
            <ul>
              @for (planningPhase of planningPhases; track planningPhase) {
                <li
                  (click)="planningPhase != currSelectedPhase && onSelectPhaseType(planningPhase)">
                  <div class="ub-list-item">{{ planningPhase | translate }}</div>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    }
  </div>
}

<!-- tag filter common end  -->
@if (isPowerQualityScreen() && !isTagCreationScreen) {
  <div class="ml-auto d-flex align-items-center">
    <ng-container>
      <div class="ub-tab-topbar">
        <ul>
          <li
            [ngClass]="{ active: selectedView === 'standard' }"
            (click)="onViewClick('standard')">
            {{ 'standard' | translate }}
          </li>
          <li
                [ngClass]="{ active: selectedView === 'temporal',
                'disabled': !isTemporalViewEnable  }"
            (click)="isTemporalViewEnable && onViewClick('temporal')" matTooltipClass="ub-tooltip"
            matTooltip="{{ !isTemporalViewEnable ? ('temporal_view_disable_info'  | translate) : null}}">
            {{ 'temporal' | translate }}
          </li>
        </ul>
      </div>
      <div class="ub-substation-buttons">
        <!-- <button mat-button class="ub-button ub-button-radius" disabled>
        <ubi-cell-icons name="laterals-icon"></ubi-cell-icons>
      </button> -->
      <button mat-button class="ub-button ub-button-radius ub-button-white" matTooltipClass="ub-tooltip"  matTooltip="{{ 'show_hide_feeders' | translate }}"
        [ngClass]="{ active: isFeederViewSelected && isFeederViewEnabled }" [disabled]="!isFeederViewEnabled"
        (click)="toggleFeederView()" matTooltipClass="ub-tooltip" matTooltip="{{ 'feeders' | translate }}">
        <ubi-cell-icons name="feeders-icon"></ubi-cell-icons>
      </button>
      <button mat-button class="ub-button ub-button-radius ub-button-white" matTooltipClass="ub-tooltip"  matTooltip="{{ 'show_hide_substations' | translate }}"
        [ngClass]="{ active: isSubstationViewSelected && isSubstationViewEnabled }"
        [disabled]="!isSubstationViewEnabled" (click)="toggleSubstationView()" matTooltipClass="ub-tooltip" matTooltip="{{ 'substations' | translate }}">
        <ubi-cell-icons name="substations-icon"></ubi-cell-icons>
      </button>
    </div>
    <!-- light  node status starts -->
  </ng-container>
</div>
}
@if (isTagCreationScreen || !isPowerQualityScreen()) {
  <ubi-cell-top-bar-node-status [mainScreen]="mainScreen" [subScreen]="subScreen" class="ml-auto"></ubi-cell-top-bar-node-status>
}
@if (displayRefreshRate) {
  <ubi-cell-top-bar-refresh-rate [currentView]="currentView"
  [hidden]="!(subScreen == 'operational' || subScreen == 'digital_inspection' || subScreen == 'network' || subScreen == 'maintenance' || subScreen == 'connected_nodes' || subScreen == 'camera_status')"></ubi-cell-top-bar-refresh-rate>
}
</div>